import finishBlue from "@/assets/finish-blue.png.asset.json";
import finishBlack from "@/assets/finish-black.png.asset.json";
import finishSilver from "@/assets/finish-silver.png.asset.json";

export const FINISH_IMAGES: Record<string, string> = {
  blue: finishBlue.url,
  black: finishBlack.url,
  silver: finishSilver.url,
  grey: finishSilver.url,
  gray: finishSilver.url,
};

export function finishImage(label: string) {
  const key = label.toLowerCase();
  const match = Object.keys(FINISH_IMAGES).find((k) => key.includes(k));
  return match ? FINISH_IMAGES[match] : undefined;
}
